const KNOWN_DEPARTMENTS = [
  {
    key: "warehouse",
    match: (name) => name.includes("magazyn"),
    color: "#0abe8c",
  },
  {
    key: "marketing",
    match: (name) => name.includes("marketing"),
    color: "#567cfb",
  },
  {
    key: "it",
    match: (name) =>
      name === "it" ||
      name.startsWith("it ") ||
      name.endsWith(" it") ||
      name.includes(" it "),
    color: "#ff9800",
  },
];

const FALLBACK_COLORS = [
  "#fd397a",
  "#9c27b0",
  "#795548",
  "#607d8b",
  "#e91e63",
  "#009688",
  "#673ab7",
  "#3f51b5",
];

const NO_DEPARTMENT_COLOR = "#a2a5b9";

const normalizeDepartmentName = (name) => (name || "").toLowerCase().trim();

export const getDepartmentSortPriority = ({
  department_name,
  department_id,
}) => {
  const name = normalizeDepartmentName(department_name);

  if (name.includes("magazyn") || department_id === 1) {
    return 0;
  }

  if (name.includes("marketing") || department_id === 2) {
    return 1;
  }

  return 2;
};

export const sortAbsencesForCalendar = (absences) =>
  [...absences].sort((a, b) => {
    const aAccepted = a.is_accepted ? 0 : 1;
    const bAccepted = b.is_accepted ? 0 : 1;

    if (aAccepted !== bAccepted) {
      return aAccepted - bAccepted;
    }

    const aDepartment = getDepartmentSortPriority(a);
    const bDepartment = getDepartmentSortPriority(b);

    if (aDepartment !== bDepartment) {
      return aDepartment - bDepartment;
    }

    const aName = `${a.last_name} ${a.first_name}`.toLowerCase();
    const bName = `${b.last_name} ${b.first_name}`.toLowerCase();

    return aName.localeCompare(bName, "pl");
  });

export const getDepartmentColor = ({ department_name, department_id }) => {
  const name = normalizeDepartmentName(department_name);

  if (!name && !department_id) {
    return NO_DEPARTMENT_COLOR;
  }

  const known = KNOWN_DEPARTMENTS.find(({ match }) => match(name));

  if (known) {
    return known.color;
  }

  const paletteIndex = Math.abs(
    (department_id || name.charCodeAt(0) || 0) % FALLBACK_COLORS.length,
  );

  return FALLBACK_COLORS[paletteIndex];
};

export const getDepartmentLegendItems = (absences) => {
  const items = new Map();

  absences.forEach(({ department_id, department_name }) => {
    const label = department_name?.trim() || "Brak działu";
    const key = normalizeDepartmentName(label) || "none";

    if (!items.has(key)) {
      items.set(key, {
        key,
        label,
        color: getDepartmentColor({ department_name, department_id }),
      });
    }
  });

  return Array.from(items.values()).sort((a, b) => {
    const priorityDiff =
      getDepartmentSortPriority({
        department_name: a.label,
        department_id: null,
      }) -
      getDepartmentSortPriority({
        department_name: b.label,
        department_id: null,
      });

    if (priorityDiff !== 0) {
      return priorityDiff;
    }

    return a.label.localeCompare(b.label, "pl");
  });
};
